import { useSelector } from "react-redux"

const useAgencyConfigurations = () => {
  const agencyConfiguration = useSelector(state => state?.app?.user?.info?.AgencyConfiguration)

  return agencyConfiguration
}

export default useAgencyConfigurations
